import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Cards2Teenpatti() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  const VIDEO_ID = "patti2";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      gameName={"2 Cards Teenpatti"}
    >
      {/* <div className="casino-header">
              <span className="casino-name">
                2 Cards Teenpatti
                <a className="ms-1">
                  <small>Rules</small>
                </a>
              </span>
              <span className="casino-rid d-none d-xl-inline-block">
                <small>
                  Round ID: <span>136250425135459</span>
                </small>
              </span>
            </div> */}
      {/* <ul className="nav nav-tabs menu-tabs">
                <li className="nav-item">
                  <div className="nav-link active">Game</div>
                </li>
                <li className="nav-item">
                  <div className="nav-link">Placed Bet (0)</div>
                </li>
              </ul> */}
      {/* <div className="pe-2">
                <span className="casino-rid">
                  Round ID: <span>136250425135459</span>
                </span>
              </div> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container">
                  <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/patti2/e9599d62-f306-405f-810f-38d60659edbc?ip=122.160.119.41" /> */}
      {/* </div>
                </div> */}
      {/* <div className="casino-video-cards">
                  <div className="">
                    <div className="flip-card-container">
                      <div className="flip-card">
                        <div className="flip-card-inner ">
                          <div className="flip-card-front">
                            <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/KHH.jpg" />
                          </div>
                          <div className="flip-card-back">
                            <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/KHH.jpg" />
                          </div>
                        </div>
                      </div>
                      <div className="flip-card">
                        <div className="flip-card-inner ">
                          <div className="flip-card-front">
                            <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/7CC.jpg" />
                          </div>
                          <div className="flip-card-back">
                            <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/7CC.jpg" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-1">
                    <div className="flip-card-container">
                      <div className="flip-card">
                        <div className="flip-card-inner ">
                          <div className="flip-card-front">
                            <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/8SS.jpg" />
                          </div>
                          <div className="flip-card-back">
                            <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/8SS.jpg" />
                          </div>
                        </div>
                      </div>
                      <div className="flip-card">
                        <div className="flip-card-inner ">
                          <div className="flip-card-front">
                            <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                          </div>
                          <div className="flip-card-back">
                            <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-table-left-box">
              <div className="casino-table-body">
                <div className="casino-table-row ">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Player A
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "Player A")}
                      </p>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back suspended-box"> */}
                  <div className="casino-odds-box back">
                    {/* <span className="casino-odds">2.17</span> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Player A", casinoData, dispatch, "back")
                      }
                    >
                      {/* <span className="casino-odds">1.6</span> */}
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player A", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box lay suspended-box"> */}
                  <div className="casino-odds-box lay">
                    {/* <span className="casino-odds">2.33</span> */}
                    <div
                      className={`casino-odds-box lay  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Player A", casinoData, dispatch, "lay")
                      }
                    >
                      <span className="casino-odds">
                        {getOddForEntity("Player A", casinoData, false)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="casino-table-row mini-baccarat">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Mini Baccarat A
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Mini Baccarat A"
                        )}
                      </p>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div className="casino-odds-box back">
                    {/* <span className="casino-odds">2.17</span> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Mini Baccarat A", casinoData, dispatch)
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Mini Baccarat A", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="casino-table-row ">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Total A
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "Total A")}
                      </p>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box lay suspended-box"> */}
                  <div className="casino-odds-box lay">
                    {/* <span className="casino-odds">2.33</span> */}
                    <div
                      className={`casino-odds-box lay  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Total A", casinoData, dispatch, "lay")
                      }
                    >
                      {/* <span className="casino-volume">
                              
                              </span> */}
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Total A", casinoData, false)}
                      </span>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back suspended-box"> */}
                  <div className="casino-odds-box back">
                    {/* <span className="casino-odds">2.17</span> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Total A", casinoData, dispatch, "true")
                      }
                    >
                      {/* <span className="casino-volume">
                                {" "}
                              </span> */}
                      <span className="casino-odds">
                        {getOddForEntity("Total A", casinoData, true)}
                      </span>
                      {/* <span className="casino-odds">
                        {getOddForEntity("Total A", casinoData, true, true)}
                      </span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-table-box-divider" />
            <div className="casino-table-right-box">
              <div className="casino-table-body">
                <div className="casino-table-row ">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Player B
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "Player B")}
                      </p>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back suspended-box"> */}
                  <div className="casino-odds-box back">
                    {/* <span className="casino-odds">2.17</span> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Player B", casinoData, dispatch, "true")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player B", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box lay suspended-box"> */}
                  <div className="casino-odds-box lay">
                    {/* <span className="casino-odds">2.33</span> */}
                    <div
                      className={`casino-odds-box lay  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Player B", casinoData, dispatch, "false")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Player B", casinoData, false)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="casino-table-row mini-baccarat">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Mini Baccarat B
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Mini Baccarat B"
                        )}
                      </p>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div className="casino-odds-box back">
                    {/* <span className="casino-odds">2.17</span> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Mini Baccarat B", casinoData, dispatch)
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Mini Baccarat B", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="casino-table-row ">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">
                      Total B
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "Total B")}
                      </p>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box lay"> */}
                  {/* <span className="casino-volume">14</span> */}
                  <div className="casino-odds-box lay">
                    {/* <span className="casino-odds">2.33</span> */}
                    <div
                      className={`casino-odds-box lay  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Total B", casinoData, dispatch, "false")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Total B", casinoData, false)}
                      </span>
                    </div>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  {/* <span className="casino-volume">15</span> */}
                  <div className="casino-odds-box back">
                    {/* <span className="casino-odds">2.17</span> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Total B", casinoData, dispatch, "true")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Total B", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="casino-table-full-box color-plus my-2">
            {/* <div className="casino-odds-box back suspended-box"> */}
            <div className="casino-odds-box back">
              {/* <span className="casino-odds">2.17</span> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Color Plus", casinoData, dispatch)}
              >
                <span className="casino-odds">
                  {getOddForEntity("Color Plus", casinoData, true)}
                </span>
              </div>
            </div>
            <p className="casino-nation-book d-none d-md-block w-100">
              {getCasinoPlExposureByRunner(casinoPlData, "Color Plus")}
            </p>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
          <span>Last Result</span>
          <span>
            <a href="/casino-results/patti2">View All</a>
          </span>
        </div>
        <div className="casino-last-results">
          <span className="result result-b">B</span>
          <span className="result result-b">B</span>
          <span className="result result-b">B</span>
          <span className="result result-b">B</span>
          <span className="result result-a">A</span>
          <span className="result result-a">A</span>
          <span className="result result-b">B</span>
          <span className="result result-b">B</span>
          <span className="result result-a">A</span>
          <span className="result result-b">B</span>
        </div> */}
        <div className="sidebar-box my-bet-container mt-2 d-xl-none">
          <div className="sidebar-title">
            <h4>Rules</h4>
          </div>
          <div className="">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th colSpan={2} className="text-center">
                      Color Plus Rules
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Three card Sequence</td>
                    <td>1 TO 3</td>
                  </tr>
                  <tr>
                    <td>Four card color</td>
                    <td>1 TO 9</td>
                  </tr>
                  <tr>
                    <td>Four card Sequence</td>
                    <td>1 TO 9</td>
                  </tr>
                  <tr>
                    <td>Three of a kind</td>
                    <td>1 TO 12</td>
                  </tr>
                  <tr>
                    <td>Three card pure Sequence</td>
                    <td>1 TO 15</td>
                  </tr>
                  <tr>
                    <td>Four card pure Sequence</td>
                    <td>1 TO 150</td>
                  </tr>
                  <tr>
                    <td>Four of a kind</td>
                    <td>1 TO 200</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
          <div className="sidebar-box my-bet-container">
            <div className="sidebar-title">
              <h4>My Bet</h4>
            </div>
            <div className="my-bets">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Matched Bet</th>
                      <th className="text-end">Odds</th>
                      <th className="text-end">Stake</th>
                    </tr>
                  </thead>
                  <tbody />
                </table>
              </div>
            </div>
          </div>
          <div className="sidebar-box my-bet-container">
            <div className="sidebar-title">
              <h4>Rules</h4>
            </div>
            <div className="">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th colSpan={2} className="text-center">
                        Color Plus Rules
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Three card Sequence</td>
                      <td>1 TO 3</td>
                    </tr>
                    <tr>
                      <td>Four card color</td>
                      <td>1 TO 9</td>
                    </tr>
                    <tr>
                      <td>Four card Sequence</td>
                      <td>1 TO 9</td>
                    </tr>
                    <tr>
                      <td>Three of a kind</td>
                      <td>1 TO 12</td>
                    </tr>
                    <tr>
                      <td>Three card pure Sequence</td>
                      <td>1 TO 15</td>
                    </tr>
                    <tr>
                      <td>Four card pure Sequence</td>
                      <td>1 TO 150</td>
                    </tr>
                    <tr>
                      <td>Four of a kind</td>
                      <td>1 TO 200</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}
    </CasinoPage>
  );
}
